






































import {
  AchievementPerView,
  DEFAULT_ACHIEVEMENTS_PER_VIEW,
  DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
  DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
  DEFAULT_SM_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
  GeekProfileAchievement,
} from '@/models/geek-profile';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';
import {WindowBreakpoint} from '@/models';

export default Vue.extend({
  name: 'AchievementsSwiper',
  props: {
      title: String,
      description: String,
  },
  data() {
    return {
      loader: {
        isAchievementListPending: false,
      },
      isSwipeArrowVisible: true,
      achievementsPerView: {
        default: DEFAULT_ACHIEVEMENTS_PER_VIEW,
        smResolution: DEFAULT_SM_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
        mdResolution: DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
        lgResolution: DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
      } as AchievementPerView,
    };
  },
  updated() {
    this.displayArrows();
  },
  created() {
    window.addEventListener('resize', this.displayArrows);
  },
  destroyed() {
    window.removeEventListener('resize', this.displayArrows);
  },
    methods: {
    displayArrows() {
      const width = document.body.clientWidth;

      if (width > WindowBreakpoint.Large && this.achievements.length > DEFAULT_ACHIEVEMENTS_PER_VIEW) {
        this.isSwipeArrowVisible = true;
      } else if (width > WindowBreakpoint.Medium && width <= WindowBreakpoint.Large
        && this.achievements.length > DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW) {
          this.isSwipeArrowVisible = true;
      } else if (width > WindowBreakpoint.Small && width <= WindowBreakpoint.Medium
        && this.achievements.length > DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW) {
          this.isSwipeArrowVisible = true;
      } else if (width <= WindowBreakpoint.Small
        && this.achievements.length > DEFAULT_SM_RESOLUTION_ACHIEVEMENTS_PER_VIEW) {
          this.isSwipeArrowVisible = true;
      } else {
        this.isSwipeArrowVisible = false;
      }
    },
  },
  computed: {
    achievements(): GeekProfileAchievement[] {
      return typedStore(this).state.achievements.geeksAchievements;
    },
    swiperOptions(): any {
      // These calculations are the workaround because the slider is broken, and the `centeredSlides` flag doesn't work.
      if (this.achievements.length <= DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW) {
        this.achievementsPerView.default = this.achievements.length;
        this.achievementsPerView.mdResolution = this.achievements.length;
        this.achievementsPerView.lgResolution = this.achievements.length;
      } else if (this.achievements.length === DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW) {
        this.achievementsPerView.default = this.achievements.length;
        this.achievementsPerView.mdResolution = DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW;
        this.achievementsPerView.lgResolution = DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW;
      } else if (this.achievements.length === DEFAULT_ACHIEVEMENTS_PER_VIEW) {
        this.achievementsPerView.default = DEFAULT_ACHIEVEMENTS_PER_VIEW;
        this.achievementsPerView.mdResolution = DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW;
        this.achievementsPerView.lgResolution = DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW;
      } else {
        this.achievementsPerView.default = DEFAULT_ACHIEVEMENTS_PER_VIEW;
        this.achievementsPerView.mdResolution = DEFAULT_MD_RESOLUTION_ACHIEVEMENTS_PER_VIEW;
        this.achievementsPerView.lgResolution = DEFAULT_LG_RESOLUTION_ACHIEVEMENTS_PER_VIEW;
      }

      return {
        slidesPerView: this.achievementsPerView.default,
        spaceBetween: 10,
        slidesPerGroup: this.achievementsPerView.default,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          [WindowBreakpoint.Large]: {
            slidesPerView: this.achievementsPerView.lgResolution,
            spaceBetween: 10,
            slidesPerGroup: this.achievementsPerView.lgResolution,
          },
          [WindowBreakpoint.Medium]: {
            slidesPerView: this.achievementsPerView.mdResolution,
            spaceBetween: 10,
            slidesPerGroup: this.achievementsPerView.mdResolution,
          },
          [WindowBreakpoint.Small]: {
            slidesPerView: DEFAULT_SM_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
            spaceBetween: 10,
            slidesPerGroup: DEFAULT_SM_RESOLUTION_ACHIEVEMENTS_PER_VIEW,
          },
        },
      };
    },
    isMyProfile(): boolean {
      return typedStore(this).state.geek.geek.id === typedStore(this).state.geek.current.id;
    },
    getComponentTitle(): string {
      return this.isMyProfile ? this.$t('geek-profile.achievements-tab-my') as string :
        this.$t('geek-profile.achievements-tab-geek') as string;
    },
  },
});
